import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchOldAccountJWTParams,
  selectOldAccountJWT,
  selectOldAccountJWTLoading,
  selectOldAccountJWTState,
  useFetchOldAccountJWTQuery,
  useLazyFetchOldAccountJWTQuery,
} from '../fetchOldAccountJWT';

export interface IUseOldAccountJWTQueryProps
  extends IUseQueryProps,
    IFetchOldAccountJWTParams {}

export const useOldAccountJWTQuery = ({
  account,
  skipFetching,
}: IUseOldAccountJWTQueryProps) => {
  const params = useMemo(
    (): IFetchOldAccountJWTParams => ({ account }),
    [account],
  );

  useFetchOldAccountJWTQuery(getQueryParams({ params, skipFetching }));

  const [fetchLazy] = useLazyFetchOldAccountJWTQuery();

  const handleFetchOldAccountJWT = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const oldAccountJWT = useAppSelector(state =>
    selectOldAccountJWT(state, params),
  );

  const loading = useAppSelector(state =>
    selectOldAccountJWTLoading(state, params),
  );

  const state = useAppSelector(storeState =>
    selectOldAccountJWTState(storeState, params),
  );

  return { handleFetchOldAccountJWT, loading, oldAccountJWT, params, state };
};
